/**
 * Phone helpers — single source of truth (replaces the per-file copies that
 * used to live in ResellerEmbed and ResellerCustomerPortal).
 *
 * Scope: North American numbers with an OPTIONAL +1 country code. A leading
 * "1" is treated as the +1 country code because NA area codes never start
 * with 1 — so the masker can disambiguate while the user is still typing.
 * (Full international support would need libphonenumber; out of scope here.)
 *
 * Canonical format (Todd, 2026-08-24):
 *   "9025784458"    -> "(902) 578 - 4458"
 *   "19025784458"   -> "1 (902) 578 - 4458"
 *   "1 902 578…"    -> "1 (902) 578 - …"
 */

// As-you-type input masker. Coerces to NA format; surfaces a leading "1" when a
// country code is present. Safe for partial input (backspace-friendly).
export function formatPhone(raw) {
  let digits = String(raw || '').replace(/\D/g, '');
  let cc = false;
  if (digits.startsWith('1')) { cc = true; digits = digits.slice(1); } // leading 1 = country code
  digits = digits.slice(0, 10);
  const p = cc ? '1 ' : '';
  if (digits.length === 0) return cc ? '1 ' : '';
  if (digits.length <= 3) return p + '(' + digits;
  if (digits.length <= 6) return p + '(' + digits.slice(0, 3) + ') ' + digits.slice(3);
  return p + '(' + digits.slice(0, 3) + ') ' + digits.slice(3, 6) + ' - ' + digits.slice(6);
}

// Valid = 10 digits (NA) or 11 digits with a leading 1 (+1).
export function isValidPhone(s) {
  const d = String(s || '').replace(/\D/g, '');
  return d.length === 10 || (d.length === 11 && d.startsWith('1'));
}

// Read-only display. Formats recognizable NA numbers; leaves anything else
// untouched so a stored non-NA / partial value isn't mangled.
export function displayPhone(raw) {
  return isValidPhone(raw) ? formatPhone(raw) : (raw || '');
}
